import cc from 'classcat';
import { jsx } from 'react/jsx-runtime';
import { svgCls } from './styles/svg.js';

const OctagonShape = ({
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx("svg", {
    ...svgProps,
    className: cc([svgCls, svgProps.className]),
    ref: shapeRef,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 73.935 73.935",
    fill: fillColor,
    children: /*#__PURE__*/jsx("path", {
      d: "M52.279 73.935H21.656L0 52.279V21.655L21.655 0H52.28l21.655 21.655V52.28z"
    })
  });
};

export { OctagonShape };
//# sourceMappingURL=OctagonShape.js.map
